import { render, staticRenderFns } from "./ConfigRole.vue?vue&type=template&id=752c0658&scoped=true"
import script from "./ConfigRole.vue?vue&type=script&lang=js"
export * from "./ConfigRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c0658",
  null
  
)

export default component.exports